import TastypieCollection from 'screener/collections/tastypie';
import QuestionLog from 'screener/models/question_log';


// QuestionLog Collection
export default TastypieCollection.extend({
  model: QuestionLog,
  urlRoot: QUESTIONLOG_API_URL
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/screener-app/screener/static/js/screener/collections/question_log.js
// module id = 72
// module chunks = 0